import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row w-100 mx-0 gy-2 gy-md-3 gx-0 gx-md-2 gx-xl-3" }
const _hoisted_2 = { class: "w-100 d-flex align-items-center" }
const _hoisted_3 = {
  key: 4,
  class: "position-relative w-100"
}
const _hoisted_4 = {
  key: 0,
  class: "mb-1 d-flex align-items-center"
}
const _hoisted_5 = { class: "input-label d-flex align-items-center" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "position-absolute top-50 mt-1 ms-2 d-flex align-items-center",
  style: {"z-index":"5"}
}
const _hoisted_8 = {
  class: "me-2",
  style: {"color":"var(--ch-black-30)","font-size":"var(--font-xs)"}
}
const _hoisted_9 = ["data-testid"]
const _hoisted_10 = ["data-testid"]

import { Input, PhoneNumberInput, SearchSelect, Select, TextArea, ToolTip } from '@/components/global';
import { CircleMarkIcon, InfoIcon } from '@/components/svg';

import { IFormField, InputVariant } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
    fields: {},
    form: {},
    "v$": {},
    columns: { default: 1 },
    variant: { default: 'primary' }
  },
  emits: ["update:query", "load-more-options", "on-blur", "end-icon-click"],
  setup(__props: any, { emit: __emit }) {

const hintIcon = (type?: 'success' | 'info' | 'error') => {
  if (type === 'success') return CircleMarkIcon;
  if (type === 'info') return InfoIcon;
  return null;
};

const props = __props;

const emit = __emit;

const dynamicColClass = (fieldCol?: number) => {
  const colCount = fieldCol ?? props.columns;
  const colWidth = Math.floor(12 / colCount);
  return `col-md-${colWidth}`;
};

const dynamicVariant = (fieldVariant?: InputVariant): InputVariant => {
  return fieldVariant ?? props.variant;
};

const handleQueryUpdate = (fieldName: string, value: string) => {
  emit('update:query', fieldName, value);
};

const handleLoadMore = (fieldName: string) => {
  emit('load-more-options', fieldName);
};

const handleBlur = (fieldName: string) => {
  props.v$?.[fieldName]?.$touch();
  emit('on-blur', fieldName);
};

const handleEndIconClick = (fieldName: string) => {
  emit('end-icon-click', fieldName);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields, (field) => {
      return (_openBlock(), _createElementBlock("div", {
        key: field.name,
        class: _normalizeClass(['col-12', dynamicColClass(field.cols)])
      }, [
        _createElementVNode("div", _hoisted_2, [
          (field.type === 'phone')
            ? (_openBlock(), _createBlock(_unref(PhoneNumberInput), {
                key: 0,
                modelValue: __props.form[field.name],
                "onUpdate:modelValue": ($event: any) => ((__props.form[field.name]) = $event),
                label: field.label ?? '',
                "label-icon": field.labelIcon ?? '',
                variant: dynamicVariant(field.variant),
                testId: field.testId ?? `${field.name}Input`,
                required: field.required,
                disabled: field.disabled,
                readonly: field.readonly,
                onBlur: ($event: any) => (handleBlur(field.name))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "label-icon", "variant", "testId", "required", "disabled", "readonly", "onBlur"]))
            : (field.type === 'select')
              ? (_openBlock(), _createBlock(_unref(Select), {
                  key: 1,
                  modelValue: __props.form[field.name],
                  "onUpdate:modelValue": ($event: any) => ((__props.form[field.name]) = $event),
                  label: field.label ?? '',
                  "label-icon": field.labelIcon ?? '',
                  placeholder: field.placeholder ?? '',
                  options: field.options,
                  variant: dynamicVariant(field.variant),
                  testId: field.testId ?? `${field.name}Select`,
                  required: field.required,
                  readonly: field.readonly,
                  onBlur: ($event: any) => (handleBlur(field.name))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "label-icon", "placeholder", "options", "variant", "testId", "required", "readonly", "onBlur"]))
              : (field.type === 'search-select')
                ? (_openBlock(), _createBlock(_unref(SearchSelect), {
                    key: 2,
                    modelValue: __props.form[field.name],
                    "onUpdate:modelValue": ($event: any) => ((__props.form[field.name]) = $event),
                    label: field.label ?? '',
                    "label-icon": field.labelIcon ?? '',
                    placeholder: field.placeholder ?? '',
                    options: field.options,
                    variant: dynamicVariant(field.variant),
                    testId: field.testId ?? `${field.name}SearchSelect`,
                    required: field.required,
                    "loading-options": field.loadingOptions,
                    "loading-more-options": field.loadingMoreOptions,
                    readonly: field.readonly,
                    onBlur: ($event: any) => (handleBlur(field.name)),
                    "onUpdate:query": ($event: any) => (handleQueryUpdate(field.name, $event)),
                    onLoadMoreOptions: ($event: any) => (handleLoadMore(field.name))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "label-icon", "placeholder", "options", "variant", "testId", "required", "loading-options", "loading-more-options", "readonly", "onBlur", "onUpdate:query", "onLoadMoreOptions"]))
                : (field.type === 'textarea')
                  ? (_openBlock(), _createBlock(_unref(TextArea), {
                      key: 3,
                      modelValue: __props.form[field.name],
                      "onUpdate:modelValue": ($event: any) => ((__props.form[field.name]) = $event),
                      label: field.label ?? '',
                      "label-icon": field.labelIcon ?? '',
                      placeholder: field.placeholder ?? '',
                      variant: dynamicVariant(field.variant),
                      rows: field.rows ?? 3,
                      testId: field.testId ?? `${field.name}Textarea`,
                      required: field.required,
                      disabled: field.disabled,
                      readonly: field.readonly,
                      onBlur: ($event: any) => (handleBlur(field.name))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "label-icon", "placeholder", "variant", "rows", "testId", "required", "disabled", "readonly", "onBlur"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (field.labelTooltip)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("span", _hoisted_5, [
                              _createTextVNode(_toDisplayString(field.label) + " ", 1),
                              (field.required)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "*"))
                                : _createCommentVNode("", true)
                            ]),
                            (field.labelTooltip)
                              ? (_openBlock(), _createBlock(_unref(ToolTip), {
                                  key: 0,
                                  class: "ms-1",
                                  style: {"z-index":"1","max-height":"1.375rem"},
                                  placement: field.labelTooltip.placement ?? 'right-start',
                                  color: field.labelTooltip.color ?? 'var(--ch-white)',
                                  bgColor: field.labelTooltip.bgColor ?? 'var(--ch-secondary)',
                                  maxWidth: field.labelTooltip.maxWidth ?? '17.3rem',
                                  text: field.labelTooltip.text,
                                  labelIcon: field.labelTooltip.labelIcon ?? field.labelIcon
                                }, null, 8, ["placement", "color", "bgColor", "maxWidth", "text", "labelIcon"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(Input), {
                        modelValue: __props.form[field.name],
                        "onUpdate:modelValue": ($event: any) => ((__props.form[field.name]) = $event),
                        type: field.type ?? 'text',
                        label: field.labelTooltip ? '' : (field.label ?? ''),
                        "label-icon": field.labelTooltip ? '' : (field.labelIcon ?? ''),
                        placeholder: field.loading ? '' : (field.placeholder ?? ''),
                        variant: dynamicVariant(field.variant),
                        testId: field.testId ?? `${field.name}Input`,
                        required: field.required,
                        disabled: field.disabled || field.loading,
                        readonly: field.readonly,
                        minlength: field.minlength,
                        maxlength: field.maxlength,
                        min: field.min,
                        max: field.max,
                        icon: field.icon,
                        position: field.iconPosition,
                        prefix: field.prefix,
                        suffix: field.suffix,
                        autofocus: field.autofocus,
                        onKeypress: field.onKeypress,
                        onPaste: field.onPaste,
                        onFocus: field.onFocus,
                        onBlur: ($event: any) => (handleBlur(field.name)),
                        onEndIconClick: ($event: any) => (handleEndIconClick(field.name))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "type", "label", "label-icon", "placeholder", "variant", "testId", "required", "disabled", "readonly", "minlength", "maxlength", "min", "max", "icon", "position", "prefix", "suffix", "autofocus", "onKeypress", "onPaste", "onFocus", "onBlur", "onEndIconClick"]),
                      (field.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(field.loadingText ?? 'Loading...'), 1),
                            _cache[0] || (_cache[0] = _createElementVNode("div", {
                              class: "spinner-border spinner-border-sm text-secondary",
                              role: "status"
                            }, [
                              _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                            ], -1))
                          ]))
                        : _createCommentVNode("", true)
                    ])),
          (field.outerSuffix)
            ? (_openBlock(), _createElementBlock("span", {
                key: 5,
                class: "outer-suffix align-items-center",
                style: _normalizeStyle(field.label && { marginTop: '1.5rem' })
              }, _toDisplayString(field.outerSuffix), 5))
            : _createCommentVNode("", true)
        ]),
        (__props.v$ && __props.v$[field.name] && __props.v$[field.name].$error)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "form-error",
              "data-testid": field.testId ? `${field.testId}Error` : `${field.name}Error`
            }, [
              _createElementVNode("small", null, _toDisplayString(__props.v$[field.name].$errors[0].$message), 1)
            ], 8, _hoisted_9))
          : (field.hint)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(['form-hint', `form-hint--${field.hint.type ?? 'info'}`]),
                "data-testid": field.testId ? `${field.testId}Hint` : `${field.name}Hint`
              }, [
                (hintIcon(field.hint.type))
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(hintIcon(field.hint.type)), {
                      key: 0,
                      class: "form-hint-icon",
                      fill: "currentColor",
                      stroke: "currentColor"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("small", null, _toDisplayString(field.hint.text), 1)
              ], 10, _hoisted_10))
            : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}
}

})